import React from 'react';
import styled from 'styled-components';

const Text = styled.span`
    margin-left: 0 2px;
    user-select: none;
`;

export default Text;



// WEBPACK FOOTER //
// ./components/Text.jsx